var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C4.6862 14 2 11.3138 2 8C2 4.6862 4.6862 2 8 2C11.3138 2 14 4.6862 14 8C14 11.3138 11.3138 14 8 14ZM6.134 8.702L6.1418 8.6978L6.6638 10.4198C6.731 10.6064 6.8234 10.64 6.9356 10.6244C7.0484 10.6094 7.1078 10.5488 7.1816 10.478L7.8944 9.7892L9.4244 10.922C9.704 11.0762 9.905 10.9964 9.9746 10.6628L10.9688 5.9696C11.0786 5.5328 10.8866 5.3576 10.5476 5.4968L4.7078 7.7528C4.3094 7.9124 4.3118 8.1356 4.6358 8.2346L6.134 8.7026V8.702Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.696b0d16fc9472fc7eaabb178793ca3d.svg";
export { ForwardRef as ReactComponent };